import api from '@pray/shared/utils/api';

export async function deleteDailyItem({ artistId, dailySeriesId, dailyItemId }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!dailySeriesId) throw Error('Daily Series ID is required');
  if (!dailyItemId) throw Error('Daily Item ID is required');

  const url = `/web/studio/artists/${artistId}/daily-series/${dailySeriesId}/daily-items/${dailyItemId}`;
  return api.executeDeleteRequest(url);
}
